import React from 'react';
import { isMobile } from '@/utils';

export default function (props) {
  const Component = isMobile()
    ? require('./MobileComplete').default
    : require('./WebComplete').default;

  return <Component {...props} />;
}
